import $ from 'jquery';
const $headerWrapper = $('.site-header-wrap');
const $headerNav = $('.site-header .site-header__nav');
const $full_nav_page = $('.full-page-nav')
const $full_nav_page_overlay = $('.full-page-nav-overlay')
const $headerMenu = $('.site-header__menu')
const $logo1 = $('.first-logo')
const $logo2 = $('.second-logo')
const $hamburger_menu = $('.hamburger-box')
const $white_backdrop = $('.white-backdrop')
const $full_nav_page_links = $('.full-page-main-nav li')
const $full_nav_page_secondary_links = $('.full-page-secondary-nav li')
const site_header = document.querySelector('.site-header')
const header_container = document.querySelector('header .container')
const header_links = document.querySelectorAll('nav ul li a')

const nav_items = () => {
    if ($(window).width() < 1360) {
        $headerNav.addClass('remove-nav-items')
    } 
    else {
        $headerNav.removeClass('remove-nav-items')
    }
}

$('.mobile-close, .mobile-menu-toggle').on( 'click', function () {
    $full_nav_page_links.toggleClass('show-full-nav-links')
    $full_nav_page_secondary_links.toggleClass('show-full-nav-links')
    $headerNav.toggleClass('open');
    $(this).toggleClass('is-active');
    $full_nav_page.toggleClass('open-nav')
    $full_nav_page_overlay.toggleClass('add-overlay')
    if(window.scrollY !== 0 || $('.section--hero').length === 0) {
        $logo1.toggleClass('first-logo-inactive')
        $logo2.toggleClass('second-logo-active')
        $hamburger_menu.toggleClass('change-hamburger-color')
    }
    if(window.innerWidth < 481) {
        $headerWrapper.toggleClass('nav-relative')
    }
    change_header()
    $headerMenu.toggleClass('remove-nav-items')
    if(window.scrollY === 0 && $headerNav.hasClass('open')) {
        $headerWrapper.addClass('remove-top-position')
        header_container.classList.add('widen-header-container')
        site_header.classList.add('site-header-padding')
    } else if(window.scrollY === 0 && !$headerNav.hasClass('open')) {
        $headerWrapper.removeClass('remove-top-position')
        header_container.classList.remove('widen-header-container')
        site_header.classList.remove('site-header-padding')
    } else if(window.scrollY !== 0 && $headerNav.hasClass('open')) {
        $white_backdrop.removeClass('header-background-transition')
    }

});

nav_items()

const add_backdrop = () => {
    $headerWrapper.addClass('remove-top-position')
    site_header.classList.add('site-header-padding')
    $white_backdrop.addClass('header-background-transition')
    $logo2.addClass('second-logo-active')
    $logo1.addClass('first-logo-inactive')
    header_container.classList.add('widen-header-container')
    header_links.forEach((element) => {
        element.classList.add('change-nav-text-color', 'change-nav-circles')
    })
    $hamburger_menu.addClass('change-hamburger-color')
}

const change_header = () => {
    if ($('.section--hero').length === 0) {
        add_backdrop()
        $('main').css('padding-top', '150px')
    } else {
        if(window.scrollY !== 0) {
            if (document.querySelector(".site-header__nav").classList.contains('open')) {
                //do nothing
            } else {
                add_backdrop()
            }
        } else if (window.scrollY === 0) {
            $white_backdrop.removeClass('header-background-transition')
            $hamburger_menu.removeClass('change-hamburger-color')
            $logo2.removeClass('second-logo-active')
            $logo1.removeClass('first-logo-inactive')
            if(!$headerNav.hasClass('open')) {
                $headerWrapper.removeClass('remove-top-position')
                site_header.classList.remove('site-header-padding')
                header_container.classList.remove('widen-header-container')
            }
            header_links.forEach((element) => {
                element.classList.remove('change-nav-text-color', 'change-nav-circles')
            })
        }
    }
}

$(window).on('load resize scroll', () => {
    change_header()
    nav_items()
    const $backdrop = $('.white-backdrop')
    if($(window).width() <= 480) {
        $backdrop.css('height', '')
        const height = $(".site-header-wrap").height()
        $backdrop.css('height', height)
    } else {
        $backdrop.css('height', '110px')
    }
})

